import React, { useState, useEffect } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
// import MegaMenu from '../../../shared/components/molecules/mega-menu/mega-menu';
import CaretakersMegaMenu from '../caretakers-mega-menu/caretakers-mega-menu';
import CaretakersNavMenuMobile from '../caretakers-nav-menu-mobile/caretakers-nav-menu-mobile'
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import Button from '../../../shared/components/atoms/button/button';
import useMobile from '../../../shared/hooks/useMobile'
import formatNumber from '../../../shared/utils/formatNumber';
import imgHombre from '../../../shared/assets/images/img-hombre.svg'
import imgPadre from '../../../shared/assets/images/img-padre.svg'
import imgMadre from '../../../shared/assets/images/img-madre.svg'
import transversalServices from '../../../shared/services/transversal-services'
import { StaticImage } from 'gatsby-plugin-image'
import { sessionStorage, localStorage } from '../../../shared/utils/storage'
import Cookies from 'universal-cookie'
import './caretakers-header.scss';

const CaretakersHeader = ({ activeMenu, setActiveShoppingModal }) => {

    const { homeLink } = useHomeLinkMode();
    const resultQuery = useStaticQuery(
        graphql`
        query{
            allContentfulPequeninCursoCuidadores {
                nodes {
                referenciaMenu {
                    redireccionChat
                    redireccionPremios
                    menu {
                        opcionesDelMenu {
                            nombreDeLaOpcion
                            redireccionDeLaOpcion
                            opcionesSubmenu {
                                nombreDeLaOpcion
                                redireccionDeLaOpcion
                                imagenDeLaOpcion {
                                    file {
                                        url
                                    }
                                    description
                                }
                            }
                        }
                    }
                }
                
                }
  }
        } 
    
    `
    )

    const menuOptions = resultQuery.allContentfulPequeninCursoCuidadores.nodes[0].referenciaMenu.menu.opcionesDelMenu
    const chatRedirection = resultQuery.allContentfulPequeninCursoCuidadores.nodes[0].referenciaMenu.redireccionChat

    useEffect(() => {
        let lastScrollTop = window.pageYOffset;
        window.addEventListener('scroll', function (ev) {
            let header = document.getElementById('f-m-caretakers-header')
            let logo = document.getElementById('f-m-caretakers-header__logo')
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if ((scrollTop > lastScrollTop) && (scrollTop > 100)) {
                header.classList.add("f-m-caretakers-header__hide")
                logo.classList.add("f-m-caretakers-header__logo-hide")
            } else {
                header.classList.remove("f-m-caretakers-header__hide")
                logo.classList.remove("f-m-caretakers-header__logo-hide")
            }
            lastScrollTop = scrollTop;
        });
    }, []);

    useEffect(() => {
        let lastScrollTop = window.pageYOffset;
        window.addEventListener('scroll', function (ev) {
            let search = document.getElementById('f-m-caretakers-header__start-session-icon')
            let hamMenu = document.getElementById('f-m-caretakers-header__start-session-hamburger')
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (((scrollTop > lastScrollTop) && (scrollTop > 100)) && (window.innerWidth < 1024)) {
                search.classList.add("f-m-caretakers-header__start-session-icon-float")
                hamMenu.classList.add("f-m-caretakers-header__start-session-hamburger-hide")
            } else {
                search.classList.remove("f-m-caretakers-header__start-session-icon-float")
                hamMenu.classList.remove("f-m-caretakers-header__start-session-hamburger-hide")
            }
            lastScrollTop = scrollTop;
        });

        const tokenInfo = localStorage.getItem('TOKEN_INFO') ? localStorage.getItem('TOKEN_INFO') : null
        if (tokenInfo) {
            setLoader(false)
            setLogged(true)
            let config = {
                headers: {
                    Authorization: tokenInfo.idToken,
                },
            }

            transversalServices.getInfoUser(config).then(
                response => {
                    if (response.status === 200) {
                        localStorage.setItem("ROL", response.data.rolesName[0] ? response.data.rolesName[0] : "")
                        setUserData({
                            image: getRolImage(response.data.rolesName[0] ? response.data.rolesName[0] : ""),
                            name: response.data.name.split(" ", 1)[0],
                            points: response.data.account.balance
                        });
                    } else {
                        setLoader(false)
                        setUserData(null)
                    }
                }
            )
        } else {
            setUserData(null)
            setLoader(false)
        }
    }, [])

    const mobile = useMobile();
    const [activeMegaMenu, setActiveMegaMenu] = useState(null)
    const [activeMenuMobile, setActiveMenuMobile] = useState(false)
    const [activeOption, setActiveOption] = useState(null)
    const [logged, setLogged] = useState(false);
    const [userData, setUserData] = useState(null);
    const [loader, setLoader] = useState(true);

    const menuDisplay = (item, index) => {
        if (activeMegaMenu === item) {
            setActiveMegaMenu(null)
            setActiveOption(null)
        } else {
            setActiveMegaMenu(item)
            setActiveOption(index)
        }
    }

    const activeMenuOnMobile = () => {

        document.documentElement.style.overflow = 'hidden';
        document.body.scroll = "no";
        setActiveMenuMobile(true)
    }

    const getRolImage = (rol) => {
        let image
        switch (rol) {
            case "Mamá":
                image = imgMadre
                break;

            case "Papá":
                image = imgPadre
                break;

            default:
                image = imgHombre
                break;

        }
        return image
    }

    const logOut = () => {
        const cookies = new Cookies();
        cookies.remove('cartExpired', { path: '/' })
        localStorage.clear();
        location.reload();
    }

    return (
        <header className="f-m-caretakers-header" id="f-m-caretakers-header">
            <div className="f-m-caretakers-header__logo-container"
                id="f-m-caretakers-header__logo"
                onClick={() => location.href = homeLink}
            >
                <StaticImage
                    className="f-m-caretakers-header__logo"
                    src='../../../assets/images/logo-pequenin-desktop.png'
                    alt='logo pequenin header'
                    // loading="eager"
                    placeholder="blurred"
                />
            </div>
            <div className="f-m-caretakers-header__nav-menu">
                {menuOptions.map((item, index) => (
                    <div key={index}
                        className={"f-m-caretakers-header__nav-item " + ((activeMenu === index || activeOption === index) ? "__active " : "") + (index == 0 ? " home-space" : "")}
                        onClick={() => {
                            if (item.opcionesSubmenu) {
                                menuDisplay(item, index)
                            } else {
                                location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "curso-de-cuidadores/") + (index != 0 ? item.redireccionDeLaOpcion : "")
                            }
                        }
                        }
                    >
                        <a className="f-m-caretakers-header__nav-item-name">{item.nombreDeLaOpcion}</a>
                        {(index != 0 && (item.opcionesSubmenu)) && <span className="icon-ico-arrow-down " ></span>}
                        {/* {index != 0 ?
                            <div className="f-m-caretakers-header__nav-item-menu" onClick={() => menuDisplay(item, index)}>
                                <a className="f-m-caretakers-header__nav-item-name">{item.nombreDeLaOpcion}</a>
                                <span className="icon-ico-arrow-down " ></span>
                            </div>
                            : <a className="f-m-caretakers-header__nav-item-name" href={homeLink}>{item.nombreDeLaOpcion}</a>
                        } */}
                    </div>

                ))}
            </div>

            <div className="f-m-caretakers-header__start-session">
                {loader ?
                    <div className="f-m-caretakers-header__start-session-loader" />
                    :
                    <>
                        <a href={homeLink + "buscador/"} className="f-m-caretakers-header__start-session-icon-container" id="f-m-caretakers-header__start-session-icon">
                            <span className="icon icon-ico-search f-m-caretakers-header__start-session-icon "></span>
                        </a>
                        {(logged && !mobile && userData) &&
                            <div className="f-m-caretakers-header__start-session-logged">
                                <div className="f-m-caretakers-header__start-session-logged-user-interaction">
                                    <div
                                        className="f-m-caretakers-header__start-session-logged-user"
                                        onClick={() => {
                                            let options = document.getElementById("f-m-caretakers-header__start-session-logged-options")
                                            if (options) {
                                                options.classList.toggle("__active")
                                            }
                                        }}
                                    >
                                        <div className="f-m-caretakers-header__start-session-user-image">
                                            <img
                                                src={userData.image ? userData.image : imgHombre}
                                                alt="imagen según rol"
                                            />
                                        </div>
                                        <p className="f-m-caretakers-header__start-session-user-name">{userData ? userData.name : ""}</p>
                                        <div className="f-m-caretakers-header__start-session-arrow-down">
                                            {">"}
                                        </div>
                                    </div>


                                    <div className="f-m-caretakers-header__start-session-logged-options" id="f-m-caretakers-header__start-session-logged-options">
                                        <div className="f-m-caretakers-header__start-session-logged-shadow"></div>
                                        <ul className="f-m-caretakers-header__start-session-options-container">
                                            <li
                                                className="f-m-caretakers-header__start-session-option"
                                                onClick={() => { location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "mi-perfil/"); }}
                                            >
                                                <p>Perfil</p>
                                            </li>
                                            <li
                                                className="f-m-caretakers-header__start-session-option"
                                                onClick={() => logOut()}
                                            >
                                                <p>Cerrar Sesión</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="f-m-caretakers-header__start-session-logged-points">
                                    <p className="f-m-caretakers-header__start-session-logged-number">
                                        {userData ? (formatNumber(userData.points)) + " " : ""}
                                    </p>
                                    <p className="f-m-caretakers-header__start-session-logged-word">
                                        Puntos
                                    </p>
                                </div>
                            </div>
                        }
                        <div onClick={activeMenuOnMobile} className="f-m-caretakers-header__start-session-item f-m-caretakers-header__start-session-hamburger icon icon-ico-menu" id="f-m-caretakers-header__start-session-hamburger"></div>
                        {(!logged && !userData) && !mobile &&
                            <>
                                <a className="f-m-caretakers-header__start-session-item"
                                    onClick={() => sessionStorage.setItem('PREVIOUS_PAGE', window.location.href)}
                                    href={homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "autenticacion")}
                                >
                                    Inicia sesión
                                </a>
                                <Button
                                    className={"f-a-button__primary-blue f-a-button__big f-m-caretakers-header__start-session-item f-m-button"}
                                    copy={"Regístrate"}
                                    onclick={() => {
                                        sessionStorage.setItem('PREVIOUS_PAGE', window.location.href);
                                        location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "registro");
                                    }}>
                                </Button>
                            </>
                        }
                    </>
                }
            </div>


            {/* <HeaderStartSession className="f-m-caretakers-header__start-session" setActiveMenuMobile={setActiveMenuMobile} /> */}
            {/* <NavMenu className="f-m-caretakers-header__nav-menu" activeMenu={activeMenu} menuOptions={menuOptions} activeMegaMenu={activeMegaMenu} setActiveMegaMenu={setActiveMegaMenu} />
        */}
            {activeMenuMobile && <CaretakersNavMenuMobile activeMenu={activeMenu} menuOptions={menuOptions} setActiveMenuMobile={setActiveMenuMobile} chatRedirection={chatRedirection} activeMenuMobile={activeMenuMobile} setActiveShoppingModal={setActiveShoppingModal} />}
            {activeMegaMenu && <CaretakersMegaMenu subMenu={activeMegaMenu} />}
        </header>
    )
}

export default CaretakersHeader;